import { Button, Flex } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import {
  ChartTimePeriod,
  selectedTimePeriodToLabelMap,
} from './portfolioChartUtils';
import { colors } from 'packages/common-frontend/colors';

const TimePeriodButton = ({
  timePeriod,
  onClick,
  currentSelectedTimePeriod,
}: {
  timePeriod: ChartTimePeriod;
  onClick: () => void;
  currentSelectedTimePeriod: ChartTimePeriod;
}) => {
  const isCurrentlySelected = timePeriod === currentSelectedTimePeriod;
  return (
    <Button
      height="40px"
      width="44px"
      ml="16px"
      padding="6px 16px"
      onClick={onClick}
      borderWidth="thin"
      borderColor={isCurrentlySelected ? colors.aurora[400] : colors.gray[200]}
    >
      {selectedTimePeriodToLabelMap[timePeriod]}
    </Button>
  );
};

type PortfolioTimePeriodSelectButtonsProps = {
  currentSelectedTimePeriod: ChartTimePeriod;
  onSelectTimePeriod: (timePeriod: ChartTimePeriod) => void;
};
export const PortfolioTimePeriodSelectButtons = ({
  currentSelectedTimePeriod,
  onSelectTimePeriod,
}: PortfolioTimePeriodSelectButtonsProps) => {
  return (
    <Flex>
      {_.map(ChartTimePeriod, (timePeriod) => {
        return (
          <TimePeriodButton
            key={`select-time-period-button-${timePeriod}`}
            timePeriod={timePeriod}
            onClick={() => onSelectTimePeriod(timePeriod)}
            currentSelectedTimePeriod={currentSelectedTimePeriod}
          />
        );
      })}
    </Flex>
  );
};
